import { render, staticRenderFns } from "./FormBuilderElementDropArea.vue?vue&type=template&id=22c5fbfc&scoped=true&"
import script from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElementDropArea.vue?vue&type=style&index=0&id=22c5fbfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5fbfc",
  null
  
)

export default component.exports